import { usePrevious } from '@interhyp/util-hooks';
import { useEffect } from 'react';
import { useLocation } from '@interhyp/platform-router';

const useScrollToTop = () => {
  const { pathname } = useLocation();
  const previousPathname = usePrevious(pathname);

  useEffect(() => {
    if (pathname !== previousPathname) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 500);
    }
  }, [pathname, previousPathname]);
};

export { useScrollToTop };
